import React, { useState, useEffect } from "react";
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import {
  getCategoriesRequest, getContacts_emails, getContacts_phones,
  getContacts_socials, getListNews, getProducts, getSettingsRequest,
  getListShippings
} from "../../utils/api";
import Header from "../header/header";
import MobileHeader from "../mobile/mobile_header/mobile_header";
import Main from "../../pages/main/main";
import Footer from "../footer/footer";
import BottomPanel from "../mobile/bottom_panel/bottom_panel";
import NotFound from "../../pages/not_found/not_found";
import Catalog from "../../pages/catalog/catalog";
import Profile from "../../pages/profile/profile";
import EditProfile from "../edit_profile/edit_profile";
import Login from "../../pages/user_pages/login";
import Register from "../../pages/user_pages/register";
import Agreement from "../../pages/legal_info/agreement";
import PersonalData from "../../pages/legal_info/personal_data";
import Cookie from "../../pages/legal_info/cookie";
import Activation from "../../pages/user_pages/activation";
import ProtectedRoute from "../protected_route/protected_route";
import UnregisterRoute from "../unregister_route/unregister_route";
import OnlyFromRoute from "../only_from_route/only_from_route";
import Cart from "../../pages/cart/cart";
import ForgotPassword from "../../pages/user_pages/forgot_password";
import Orders from "../../pages/orders/orders";
import News from "../../pages/news/news";
import NewsPage from "../../pages/news/news_page";
import About from "../../pages/about_pay_delivery/about";
import Slideshow from "../slideshow/slideshow";
import ProductPage from "../../pages/products/product_page";
import Products from "../../pages/products/products";
import Favorite from "../../pages/favorite/favorite";
import ResendActivation from "../../pages/user_pages/resend_activation";
import EditOrder from "../orders/edit_order";
import {
  WIDTH_LG, WIDTH_MD, WIDTH_SM, WIDTH_XL, VIOLET_INTERFACE,
  BLUE_INTERFACE, RED_INTERFACE, GREEN_INTERFACE, ORANGE_INTERFACE,
  Portal
} from "../../utils/constants";
import {
  convert_routes, setColorInterface, setSharpCorners, convert_routes_startsWith_products,
  getArrayForRoutes, changeDateFormat, getSaleAndNewCategories, setPrimaryKeyInProductsList
} from "../../utils/util_functions";
import { useResize } from "../../hooks/use-resize";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILED,
  getProductsThunk
} from "../../services/actions/products_actions";
import { getMeThunk } from "../../services/actions/user_actions";
import {
  CATEGORIES_REQUEST, CATEGORIES_REQUEST_SUCCESS, CATEGORIES_REQUEST_FAILED,
  CATEGORIES_ADD_ROUTES
} from "../../services/actions/categories_actions";
import {
  CONTACTS_REQUEST, CONTACTS_REQUEST_SUCCESS, CONTACTS_REQUEST_FAILED
} from "../../services/actions/contacts_actions";
import {
  SETTINGS_REQUEST, SETTINGS_REQUEST_SUCCESS, SETTINGS_REQUEST_FAILED
} from "../../services/actions/settings_actions";
import {
  NEWS_REQUEST_SUCCESS, NEWS_REQUEST_FAILED, NEWS_REQUEST
} from "../../services/actions/news_actions";
import {
  SHIPPINGS_REQUEST, SHIPPINGS_REQUEST_SUCCESS, SHIPPINGS_REQUEST_FAILED
} from "../../services/actions/shippings_actions";
import { START_LOADING, END_LOADING } from "../../services/actions/loading_actions";
import { RESET_PORTAL } from "../../services/actions/portal_actions";
import Modal from "../modal/modal";
import ApiResult from "../api-result/api-result";
import { getCookie } from "../../utils/cookie";
import PasswordResetConfirm from "../../pages/user_pages/password_reset_confirm";
import { getPortal, getUser, getCustomer, getSettings, getRoutes, getCart } from "../../services/selectors";
import SetPassword from "../set_password/set_password";
import SetEmail from "../set_email/set_email";
import DeleteMe from "../delete_me/delete_me";
import { MENU_CATEGORIES_INIT } from "../../services/actions/menu_categories_actions";
import { menuFromCategories } from "../categories_menu/menu_container/menu_container";
import { CURR_NEWS_DEL } from "../../services/actions/curr_news_actions";
import {
  SALE_PRODUCTS_SET, NEW_PRODUCTS_SET, POPULAR_PRODUCTS_SET
} from "../../services/actions/sale_new_popular_actions";
import Firms from "../firms/firms";
import Confirm from "../api-result/confirm";
import AddFirm from "../firms/add_firm";
import PortalButtons from "../portal_buttons/portal_buttons";
import NewOrder from "../../pages/orders/new_order";
import { patchSyncCartThunk } from "../../services/actions/cart_actions";
import { getFavThunk } from "../../services/actions/fav_actions";
import { getFirmsThunk } from "../../services/actions/firms_actions";
import Order from "../../pages/orders/order";



function App() {

  const dispatch = useDispatch();

  const { portalType } = useSelector(getPortal);
  const settings = useSelector(getSettings);
  const cart = setPrimaryKeyInProductsList(useSelector(getCart).productsInCart);

  const location = useLocation();
  const navigate = useNavigate();
  const background = location.state && location.state.background;

  const customer = useSelector(getCustomer);

  const { currWidth } = useResize();

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';

  useEffect(() => {
    if (accessToken && refreshToken) {
      dispatch(getMeThunk(accessToken, refreshToken, customer));
      // запрос товаров если есть куки
      dispatch(getProductsThunk(accessToken, refreshToken));
      dispatch(patchSyncCartThunk(accessToken, refreshToken, cart));
      dispatch(getFavThunk(accessToken, refreshToken));
      dispatch(getFirmsThunk(accessToken, refreshToken, customer.id));
    } else {
      // запрос товаров если нет кук
      dispatch(getProductsThunk('', ''));
    }
  }, [dispatch]);

  useEffect(() => {
    switch (settings.color) {
      case 'BLUE': {
        setColorInterface(BLUE_INTERFACE);
        break;
      }
      case 'GREEN': {
        setColorInterface(GREEN_INTERFACE);
        break;
      }
      case 'RED': {
        setColorInterface(RED_INTERFACE);
        break;
      }
      case 'ORANGE': {
        setColorInterface(ORANGE_INTERFACE);
        break;
      }
      case 'VIOLET': {
        setColorInterface(VIOLET_INTERFACE);
        break;
      }
      default: {
        return;
      }
    }
    setSharpCorners(settings.sharp_corners);
  }, [settings]);


  useEffect(() => {
    dispatch({ type: START_LOADING });

    dispatch({ type: SETTINGS_REQUEST });
    dispatch({ type: CATEGORIES_REQUEST });
    dispatch({ type: CONTACTS_REQUEST });
    dispatch({ type: GET_PRODUCTS_REQUEST });
    dispatch({ type: NEWS_REQUEST });
    dispatch({ type: SHIPPINGS_REQUEST });
    Promise.all([
      getSettingsRequest(),
      getCategoriesRequest(),
      getContacts_phones(),
      getContacts_emails(),
      getContacts_socials(),
      getListNews(),
      getListShippings()
    ])
      .then(([
        settings,
        categories,
        phones,
        emails,
        socials,
        news,
        shippings
      ]) => {
        if (settings) {
          dispatch({
            type: SETTINGS_REQUEST_SUCCESS,
            shop_name: settings.shop_name,
            company_seller: settings.company_seller,
            color: settings.color,
            sharp_corners: settings.sharp_corners,
            show_available_products: settings.show_available_products,
            plug: settings.plug,
            max_prod_in_cart: settings.max_prod_in_cart,
            max_prod_in_fav: settings.max_prod_in_fav
          })
        } else {
          dispatch({ type: SETTINGS_REQUEST_FAILED });
        }
        if (categories) {
          dispatch({
            type: CATEGORIES_REQUEST_SUCCESS,
            categories: [...categories, ...getSaleAndNewCategories()],
            routes: [...convert_routes(categories), ...convert_routes_startsWith_products(categories)],
          });
          dispatch({
            type: MENU_CATEGORIES_INIT,
            menuCategories: [...menuFromCategories(categories), ...getSaleAndNewCategories()],
          });
        } else {
          dispatch({ type: CATEGORIES_REQUEST_FAILED });
        }
        if (phones.length || emails.length || socials.length) {
          dispatch({
            type: CONTACTS_REQUEST_SUCCESS,
            phones,
            emails,
            socials,
          });
        } else {
          dispatch({ type: CONTACTS_REQUEST_FAILED });
        }

        if (Object.entries(news).length > 0) {
          news.results = changeDateFormat(news.results);
          dispatch({ type: NEWS_REQUEST_SUCCESS, payload: news });
          dispatch({
            type: CATEGORIES_ADD_ROUTES,
            routes: getArrayForRoutes(news.results)
          });
        } else {
          dispatch({ type: NEWS_REQUEST_FAILED });
        }
        if (shippings?.length > 0) {
          dispatch({ type: SHIPPINGS_REQUEST_SUCCESS, payload: shippings });
        } else {
          dispatch({ type: SHIPPINGS_REQUEST_FAILED });
        }
      })
      .catch(Error => {
        console.log('Error =', Error);
        dispatch({ type: CONTACTS_REQUEST_FAILED });
        dispatch({ type: CATEGORIES_REQUEST_FAILED });
        dispatch({ type: NEWS_REQUEST_FAILED });
        dispatch({ type: SHIPPINGS_REQUEST_FAILED });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      })
  }, [dispatch]);


  const handleCloseModalWithBG = () => {
    dispatch({ type: RESET_PORTAL });
    dispatch({ type: CURR_NEWS_DEL });
    navigate(-1);
  }

  const handleCloseModal = () => {
    dispatch({ type: RESET_PORTAL });
  }

  return (
    <div className="page">
      {settings.plug ? <h1 className='title mta mba'>На сайте ведутся работы</h1> :
        <>
          {currWidth > WIDTH_SM.width ?
            <Header /> :
            <MobileHeader />
          }
          <Routes location={background || location}>

            {/* <Route path='/pay' element={<Pay />} /> */}
            {/* <Route path='/delivery' element={<Delivery />} /> */}
            {/* <Route path='/contacts' element={<Contacts/>} /> */}
            {/* <Route path='/docs' element={<Docs />} /> */}

            <Route path='/' element={<Main />} />
            <Route path='*' element={<NotFound />} />
            <Route path='/about' element={<About />} />
            <Route path='/cookie' element={<Cookie />} />
            <Route path='/agreement' element={<Agreement />} />
            <Route path='/personal-data' element={<PersonalData />} />
            <Route path='/cart' element={<Cart />} />
            <Route
              path='/new_order' element={<OnlyFromRoute from={
                ['/cart', '/profile/add_firm', '/new_order']} element={<NewOrder />} />}
            />
            <Route path='/favorite' element={<ProtectedRoute element={<Favorite />} />} />
            <Route path='/orders' element={<ProtectedRoute element={<Orders />} />} />
            <Route path='/orders/:token' element={<ProtectedRoute element={<Order />} />} />
            {/* <Route path='/messages' element={<ProtectedRoute element={<Messages />} />}/> */}
            {/* <Route path='/messages/:token' element={<ProtectedRoute element={<Message />} />}/> */}


            <Route path='/news' element={<News />} />
            <Route path='/news/:token' element={<NewsPage />} />

            <Route path='/products' element={<Products />} />
            <Route path='/products/:slug1/:slug2/:slug3/:slug4' element={<ProductPage />} />
            <Route path='/products/:slug1/:slug2/:slug3' element={<ProductPage />} />
            <Route path='/products/:slug1/:slug2' element={<ProductPage />} />
            <Route path='/products/:slug1' element={<ProductPage />} />

            <Route path='/catalog' element={<Catalog />} />
            <Route path='/catalog/:slug1' element={<Catalog />} />
            <Route path='/catalog/:slug1/:slug2' element={<Catalog />} />
            <Route path='/catalog/:slug1/:slug2/:slug3' element={<Catalog />} />

            <Route path='/profile' element={<ProtectedRoute element={<Profile />} />}>
              <Route path='/profile/firms' element={<ProtectedRoute element={<Firms />} />} />
              <Route path='/profile/delete' element={<ProtectedRoute element={<DeleteMe />} />} />
              <Route path='/profile/set_email' element={<ProtectedRoute element={<SetEmail />} />} />
              <Route path='/profile/set_password' element={<ProtectedRoute element={<SetPassword />} />} />
              <Route path='/profile/add_firm' element={<ProtectedRoute element={<AddFirm />} />} />
              <Route path='/profile/me' element={<ProtectedRoute element={<EditProfile />} />} />
            </Route>

            <Route path="/login" element={
              <UnregisterRoute element={<Login />} />
            } replace />
            <Route path="/register" element={
              <UnregisterRoute element={<Register />} />
            } replace />
            <Route path="/forgot-password" element={
              <UnregisterRoute element={<ForgotPassword />} />
            } replace />
            <Route path="/resend-activation" element={
              <UnregisterRoute element={<ResendActivation />} />
            } replace />
            <Route path='/activate/:uid/:token' element={
              <UnregisterRoute element={<Activation />} />
            } />
            <Route path='/password/reset/confirm/:uid/:token' element={
              <UnregisterRoute element={<PasswordResetConfirm />} />
            } />
          </Routes>

          <Footer />
          {currWidth <= WIDTH_SM.width &&
            <BottomPanel />
          }
          {(portalType === Portal.ApiResult) &&
            <Modal onClose={handleCloseModal}>
              <ApiResult />
            </Modal>
          }
          {(portalType === Portal.Slideshow) &&
            <Modal onClose={handleCloseModal} backing={false}>
              <Slideshow />
            </Modal>
          }
          {(portalType === Portal.Confirm) &&
            <Modal onClose={handleCloseModal}>
              <Confirm />
            </Modal>
          }
          {(portalType === Portal.Buttons) &&
            <Modal onClose={handleCloseModal} backingWhite={true}>
              <PortalButtons />
            </Modal>
          }
          {(portalType === Portal.EditOrder) &&
            <Modal onClose={handleCloseModal} backingWhite={true}>
              <EditOrder />
            </Modal>
          }
        </>
      }
    </div>
  );
}

export default App;
